import { Outlet } from 'react-router-dom';

import TolerancesHeader from './TolerancesHeader';

const Tolerances = () => (
  <div>
    <TolerancesHeader />
    <Outlet />
  </div>
);

export default Tolerances;
